import { render } from "./Warning.vue?vue&type=template&id=bbf80c5a&scoped=true"
import script from "./Warning.vue?vue&type=script&lang=js"
export * from "./Warning.vue?vue&type=script&lang=js"

import "./Warning.vue?vue&type=style&index=0&id=bbf80c5a&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf80c5a"]])

export default __exports__